import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyEmailRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyEmailResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyEmail = (request: VerifyEmailRequest, options?: CashRequestOptions) =>
  post<VerifyEmailRequest, VerifyEmailResponse>('/2.0/cash/verify-email', request, { ...options, rejectOnError: true })
